import React from 'react'

/**
 * Get a ref about a previous value
 *
 * @return {*} - the ref containing the value
 */
export default function usePrevious(value) {
  const ref = React.useRef()

  // store the current value after the current render
  React.useEffect(() => {
    ref.current = value
  })

  // return the content of the ref which containing the previous value, because the useEffect callback has not yet been called
  return ref.current
}
